import React from 'react';
import Button from '../../Components/Button';

const Enroll = ({ toggleDownloadForm, toggleRegistrationForm }) => {
  return (
    <section className="enroll-conatiner">
      <p className="enroll-conatiner-title">
        IT’S NEVER TOO LATE TO START. BEGIN TODAY
      </p>

      <div className="enroll-actions-conatiner">
        <Button onClick={toggleDownloadForm} text="DOWNLOAD SYLLABUS" />
        <Button onClick={toggleRegistrationForm} primary text="ENROLL TODAY" />
      </div>
    </section>
  );
};

export default Enroll;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Enroll.js